import React from 'react';
import GxList from '../../gx/GxList';
import { useTranslation } from '../../hx/useTranslation';
// eslint-disable-next-line no-unused-vars
import * as FxLog from '../../fx/FxLog';
import * as FxTable from '../../fx/FxTable';
import * as FxDat from '../../fx/FxDat';
import { useNav } from '../../hx/useNav';

import { useWindowSize } from '../../hx/useWindowSize';
import { clearStore, StoreLab } from "../../gx/GxStore";
import { useSessionStorage } from '../../hx/useSessionStorage';


const MxLabList = (props) => {
  const [{ trans }] = useTranslation();
  const [{ navTo }] = useNav();

  const size = useWindowSize();
  const [storeLab, setStoreLab] = useSessionStorage('StoreLab', StoreLab);

  const r_list = React.useRef(null);

  React.useEffect(() => {
    clearStore('StoreLab', storeLab);
    // eslint-disable-next-line
  }, []);

  const openForm = async (op, row) => {

    if (row === null) {
      storeLab.inLab = null;
    } else {
      storeLab.inLab = row.original.inLab;
    }
    setStoreLab(storeLab);

    navTo("lab-form");
  }

  const getTableColumns = () => {
    let cols = [];
    try{
      let id = -1;
      cols.push({ id: id++, Header: "ID", accessor: "inLab", show: false });
      if (size.isLarge) { // PANTALLA GRANDE
        cols.push({ id: id++, Header: trans('field.lab'), accessor: "txLab", highlight: true, width: '40%' });
        cols.push({ id: id++, Header: trans('field.type'), accessor: "txTypeLab", width: '20%' });
        cols.push({ id: id++, Header: trans('field.email'), accessor: "txEmail", width: '20%' });
        cols.push({ id: id++, Header: trans('field.mobile'), accessor: "txMobile", width: '10%' });
        cols.push({ id: id++, Header: trans('field.from'), accessor: row => ( FxTable.cellToLocalDate(row["dtFrom"]) ), width: '10%' });
      } else { // PANTALLA PEQUEÑA
        cols.push({ id: id++, Header: trans('field.lab'), accessor: "txLab", highlight: true, width: '70%' });
        cols.push({ id: id++, Header: trans('field.mobile'), accessor: "txMobile", width: '30%' });
      }
      cols.push({ id: "A", Header: "inactive", accessor: row => FxDat.isExpired(row["dtTo"]), show: false });

    } catch(error) {
      FxLog.errorx('MxLabList.getTableColumns', error)
    }
    return cols;
  }

  return (
    <div>
      <GxList
        moduleName={`${trans('field.labs')}`}
        xref={r_list}
        tooltip={`${trans('field.lab')}`}
        fullscreen
        url="labs"
        onOpenForm={openForm}
        refColors={ [ 'table_cell_color_gray|' + trans('field.inactive') ] }
        columns={getTableColumns()}
      />

    </div>
  );

}

export default MxLabList;
